import React from 'react';

export default function HeroSection({ heading, subheading, tagline }) {
  return (
    <section className="hero">
      <h1>{heading}</h1><br />
      <h2>{subheading}</h2><br />
      <h3>{tagline}</h3>
      <a href="#contact" className="cta-btn animate-toggle">Get a Demo</a>
    </section>
  );
}
